// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/font-awesome/css/font-awesome.min.css
// module id = 143
// module chunks = 0